import styled from "styled-components";
import { RowFlex } from "@/main/components/shared/styles";

export const Container = styled.div``;

export const TitleCard = styled.h4`
	margin: 0;
	display: flex;
	align-items: center;
`;
export const EmptyClaimNumber = styled.span`
	margin: 0 3.125rem 0;
`;
export const RowFlexInfoOrder = styled(RowFlex)`
	flex-direction: column;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		flex-direction: column-reverse;
		gap: 0;
	}
`;
export const AreaInfoOrder = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 0.4rem;
	width: 100%;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: 1fr;
	}
`;

export const GridItem = styled.div<{ $span?: number }>`
	grid-column: span ${({ $span = 1 }) => $span};

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		grid-column: span 1;
	}
`;

export const AreaInfoRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		flex-direction: column;
		gap: 0;
	}
`;

export const AreaInfoColumnDeliveryAddress = styled.div``;

export const BoxText = styled.div``;
export const TextInfoHeader = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	line-height: 1.43;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

export const TextInfoHeaderSingleLine = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const TextInfoHeaderDeliveryAddress = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	line-height: 1.43;
	min-height: 40px;
	max-height: 40px;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		overflow: unset;
		text-overflow: unset;
		min-height: 40px;
		max-height: unset;
		-webkit-line-clamp: unset;
		-webkit-box-orient: vertical;
	}
`;

const ContentBaseCard = styled.div`
	width: 100%;
	padding: 0.4rem 0.8rem;
`;

export const ContentBodyCard = styled(ContentBaseCard)``;

export const AreaInfoHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 1rem;
	width: 100%;

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		gap: 0.4rem;
	}
`;
export const AreaRemainingTime = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	color: ${({ theme }) => theme.pantone2726C};
	font-weight: bold;
	font-size: 1rem;
	margin: 0 0 0.2rem;
	width: 100%;
	max-width: 300px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		justify-content: flex-start;
	}
`;
export const ItemSummary = styled.span`
	margin: 0 0.5rem 0 0;
`;

export const ContentHeaderCard = styled(ContentBaseCard)`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.6rem;
	}
`;
